import React, { useState, useEffect } from "react";
import { X, ClipboardList, Loader2, CheckCircle2, CreditCard, ChevronRight, MessageSquare, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import axios from "axios";
import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const ListRequestsStatusModal = ({ onClose, onUpdate }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [payingId, setPayingId] = useState(null);

    useEffect(() => {
        let currentPhone = localStorage.getItem("buyer_phone");
        if (!currentPhone) {
            const userData = localStorage.getItem("buyer_user");
            if (userData) {
                try {
                    const parsed = JSON.parse(userData);
                    currentPhone = parsed.phone;
                } catch (e) {}
            }
        }
        
        if (currentPhone) {
            fetchRequests(currentPhone);
        } else {
            setLoading(false);
        }
    }, []);

    const fetchRequests = async (phoneToUse) => {
        const phone = phoneToUse || buyerPhone;
        if (!phone) return;
        setLoading(true);
        try {
            const res = await axios.get(`${API}/marketplace/list-requests/my-requests?phone=${phone}`);
            setRequests(res.data);
        } catch (error) {
            console.error("Error fetching requests:", error);
            toast.error("Pa kapab chaje demann ou yo.");
        } finally {
            setLoading(false);
        }
    };

    const handlePay = async (requestId) => {
        setPayingId(requestId);
        try {
            const res = await axios.post(`${API}/marketplace/list-requests/${requestId}/pay`);
            if (res.data.redirect_url) {
                window.location.href = res.data.redirect_url;
            } else {
                toast.error("Erè nan prepare peman an.");
            }
        } catch (error) {
            console.error("Payment error:", error);
            toast.error(error.response?.data?.detail || "Erè nan prepare peman an.");
        } finally {
            setPayingId(null);
        }
    };

    const handleAccept = async (requestId) => {
        try {
            await axios.post(`${API}/marketplace/list-requests/${requestId}/accept`);
            toast.success("Ou aksepte pri sa a! Ou mèt peye kounye a.");
            fetchRequests();
            if (onUpdate) onUpdate();
        } catch (error) {
            toast.error("Erè nan aksepte quote la.");
        }
    };

    const handleReject = async (requestId) => {
        if (!window.confirm("Èske w sèten ou vle rejte pri sa a epi anile demann lan?")) return;
        try {
            await axios.post(`${API}/marketplace/list-requests/${requestId}/reject`);
            toast.success("Ou rejte pri a. Demann lan anile.");
            fetchRequests();
            if (onUpdate) onUpdate();
        } catch (error) {
            toast.error("Erè nan anile demann lan.");
        }
    };

    const handleDelete = async (requestId) => {
        if (!window.confirm("Èske w sèten ou vle efase demann sa a nèt? Ou p'ap ka wè l ankò.")) return;
        try {
            await axios.delete(`${API}/marketplace/list-requests/${requestId}`);
            toast.success("Demann lan efase nèt.");
            fetchRequests();
            if (onUpdate) onUpdate();
        } catch (error) {
            toast.error("Erè nan efase demann lan.");
        }
    };

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-xl z-[100] flex items-center justify-center p-4 animate-in fade-in duration-300">
            <div className="w-full max-w-2xl relative">
                <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={onClose}
                    className="absolute -top-12 right-0 text-white hover:bg-white/10 rounded-full"
                >
                    <X className="w-8 h-8" />
                </Button>

                <Card className="border-none shadow-2xl rounded-[40px] overflow-hidden bg-white max-h-[85vh] flex flex-col">
                    <div className="bg-[#232F3E] p-8 text-white shrink-0">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-[#FF9900] rounded-xl flex items-center justify-center">
                                <ClipboardList className="w-8 h-8 text-black" />
                            </div>
                            <div>
                                <h2 className="text-2xl font-black italic tracking-tighter uppercase leading-none">Demann Lis <span className="text-[#FF9900]">Mwen Yo</span></h2>
                                <p className="text-gray-400 font-bold text-[10px] uppercase tracking-widest mt-1">Swiv estati ak fè peman</p>
                            </div>
                        </div>
                    </div>

                    <CardContent className="p-0 overflow-y-auto flex-1">
                        {loading ? (
                            <div className="p-24 text-center">
                                <Loader2 className="w-12 h-12 animate-spin text-[#FF9900] mx-auto mb-4" />
                                <p className="text-gray-400 font-black uppercase text-[10px] tracking-widest">Ap chaje lis ou yo...</p>
                            </div>
                        ) : requests.length > 0 ? (
                            <div className="divide-y divide-gray-50">
                                {requests.map((req) => (
                                    <div key={req.id} className="p-8 hover:bg-gray-50/50 transition-all group">
                                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                                            <div className="space-y-3 flex-1">
                                                <div className="flex items-center gap-3">
                                                    <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest shadow-sm ${
                                                        req.status === 'paid' ? 'bg-green-500 text-white' :
                                                        req.status === 'confirmed' ? 'bg-purple-500 text-white' :
                                                        req.status === 'quoted' ? 'bg-blue-500 text-white' :
                                                        'bg-amber-100 text-amber-600'
                                                    }`}>
                                                        {req.status === 'pending' ? 'Atant Pri' : 
                                                         req.status === 'quoted' ? 'Pri Disponib' : 
                                                         req.status === 'confirmed' ? 'Konfime' :
                                                         req.status === 'paid' ? 'Peye' : req.status}
                                                    </span>
                                                    <span className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                                                        {new Date(req.created_at).toLocaleDateString()}
                                                    </span>
                                                </div>
                                                <h4 className="font-black text-gray-900 text-lg leading-tight uppercase tracking-tight italic">Magazen: {req.seller_name}</h4>
                                                <p className="text-sm font-bold text-gray-500 italic line-clamp-1">"{req.items_text}"</p>
                                                
                                                {req.items && req.items.length > 0 && (
                                                    <div className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm space-y-2">
                                                        <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-2 border-b border-gray-50 pb-1">Atik Machann nan mete pri yo:</p>
                                                        {req.items.map((item, i) => {
                                                            const isAvailable = item.available !== false;
                                                            return (
                                                                <div key={i} className={`flex justify-between text-[11px] font-bold ${isAvailable ? 'text-gray-700' : 'text-red-400 line-through opacity-60'}`}>
                                                                    <div className="flex items-center gap-2">
                                                                        {!isAvailable && <X className="w-3 h-3 text-red-500" />}
                                                                        <span>{item.name}</span>
                                                                    </div>
                                                                    <span className={isAvailable ? 'text-gray-900 font-black' : 'text-red-500 text-[9px] font-black uppercase'}>
                                                                        {isAvailable ? `${item.price_htg.toLocaleString()} HTG` : 'PA DISPONIB'}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                        {req.platform_fee_htg > 0 && (
                                                            <div className="pt-2 flex justify-between items-center px-4 mt-2">
                                                                <span className="text-[10px] font-black text-gray-500">FRE SISTÈM (8%):</span>
                                                                <span className="text-[11px] font-black text-gray-700">+{req.platform_fee_htg.toLocaleString()} HTG</span>
                                                            </div>
                                                        )}
                                                        <div className="pt-2 border-t border-gray-50 flex justify-between items-center bg-gray-50/50 -mx-4 px-4 py-2 mt-2">
                                                            <span className="text-[10px] font-black uppercase">Total pou Peye:</span>
                                                            <span className="text-lg font-black italic text-gray-900 tracking-tighter">{req.total_htg?.toLocaleString()} HTG</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex flex-col gap-3 shrink-0">
                                                {req.status === 'quoted' && (
                                                    <div className="flex flex-col gap-2 w-full">
                                                        <Button 
                                                            onClick={() => handleAccept(req.id)}
                                                            className="bg-purple-600 hover:bg-black text-white h-12 rounded-xl font-black uppercase text-[10px] tracking-widest shadow-xl shadow-purple-200"
                                                        >
                                                            AKSEPTE PRI SA A
                                                        </Button>
                                                        <Button 
                                                            onClick={() => handleReject(req.id)}
                                                            variant="outline"
                                                            className="text-red-500 hover:text-red-600 hover:bg-red-50 h-10 rounded-xl font-black uppercase text-[10px] tracking-widest"
                                                        >
                                                            REJTE PRI SA A (ANILE)
                                                        </Button>
                                                    </div>
                                                )}
                                                {req.status === 'cancelled' && (
                                                    <div className="bg-red-50 px-4 py-3 rounded-xl border border-red-100 flex items-center justify-between gap-2">
                                                        <span className="text-[9px] font-black text-red-700 uppercase tracking-widest">Ou te anile l</span>
                                                        <Button onClick={() => handleDelete(req.id)} variant="ghost" size="sm" className="h-6 px-3 text-[9px] bg-white text-red-600 hover:bg-red-600 hover:text-white rounded-full">Efase Nèt</Button>
                                                    </div>
                                                )}
                                                {req.status === 'confirmed' && (
                                                    <div className="flex flex-col gap-2 w-full">
                                                        <Button 
                                                            onClick={() => handlePay(req.id)}
                                                            disabled={payingId === req.id}
                                                            className="bg-[#FF9900] hover:bg-black text-black hover:text-white h-14 px-8 rounded-xl font-black uppercase text-xs tracking-widest shadow-xl shadow-orange-500/20 flex gap-3 italic"
                                                        >
                                                            {payingId === req.id ? <Loader2 className="w-5 h-5 animate-spin" /> : <CreditCard className="w-5 h-5" />}
                                                            PEYE AK MONCASH
                                                        </Button>
                                                        <Button 
                                                            onClick={() => handleReject(req.id)}
                                                            variant="ghost"
                                                            className="text-red-500 hover:text-red-600 hover:bg-transparent h-8 rounded-xl font-black uppercase text-[9px] tracking-widest"
                                                        >
                                                            M Pa Vle L Ankò (Anile)
                                                        </Button>
                                                    </div>
                                                )}
                                                {req.status === 'paid' && (
                                                   <div className="flex flex-col items-center gap-2">
                                                        <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center text-green-500 border border-green-100">
                                                            <CheckCircle2 className="w-6 h-6" />
                                                        </div>
                                                        <span className="text-[9px] font-black text-green-500 uppercase tracking-widest animate-pulse">Tranzaksyon Fin Reyisi!</span>
                                                   </div>
                                                )}
                                                {req.status === 'pending' && (
                                                    <div className="bg-amber-50 px-4 py-3 rounded-xl border border-amber-100 flex items-center gap-2">
                                                        <Loader2 className="w-4 h-4 animate-spin text-amber-600" />
                                                        <span className="text-[9px] font-black text-amber-900 uppercase tracking-widest">En Verifikasyon...</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="p-24 text-center">
                                <ClipboardList className="w-16 h-16 text-gray-100 mx-auto mb-6" />
                                <h3 className="text-xl font-black text-gray-900 mb-2 uppercase tracking-tighter italic">Ou poko gen okenn lis</h3>
                                <p className="text-gray-400 font-bold text-xs uppercase tracking-widest mb-8">Kòmanse voye lis ou yo bay machann kounye a.</p>
                                <Button onClick={onClose} variant="outline" className="h-12 px-8 rounded-xl font-black uppercase tracking-widest text-[10px]">OK, N AP KONPRANN</Button>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};
